import React, { FunctionComponent } from 'react';
import { View, Text } from '@upstox/upstox-ui';
import IPOAnalysis from '../IPOAnalysis';
import { stateToHTML } from 'draft-js-export-html';
import DOMPurify from 'isomorphic-dompurify';
import { convertFromRaw, EditorState } from 'draft-js';
import IPOInfo from '../IPOInfo';
import PreApplyInfoCard from '../InfoCard';
import RegistrarInfoCard from '../RegistrarInfoCard';
import RedherringCard from '../RedherringCard';
import Faqs from '../Faqs';
import * as css from './OverviewTab.style';
import { Ipo } from 'store/types';

interface Props {
  ipoDetails: Ipo;
  isSeoApp?: boolean;
}

export const OverViewTab: FunctionComponent<Props> = ({
  ipoDetails,
  isSeoApp = false,
}) => {
  const setContent = (content: any) => {
    if (content && typeof content === 'string') {
      return DOMPurify.sanitize(`<p>${content}</p>`);
    } else if (content && typeof content === 'object') {
      return DOMPurify.sanitize(
        stateToHTML(
          EditorState.createWithContent(
            convertFromRaw(content),
          ).getCurrentContent(),
        ),
      );
    } else {
      return '<p/>';
    }
  };

  return (
    <View flexDirection="column" css={css.fullWidth}>
      {!isSeoApp && (
        <IPOInfo
          biddingStartDate={ipoDetails?.biddingStartDate}
          biddingEndDate={ipoDetails?.biddingEndDate}
          lotSize={ipoDetails?.lotSize}
          issueSize={ipoDetails?.issueSize}
          minPrice={ipoDetails?.minPrice}
          minQuantity={ipoDetails?.minBidQuantity}
        />
      )}

      {ipoDetails?.status === 'preApply' && (
        <View css={css.preApplyWrapper} className="full-width">
          <PreApplyInfoCard
            linkText="Learn more about pre-applying"
            description={`${ipoDetails?.name} is available for Pre applying right now.`}
            showLink
          />
        </View>
      )}

      <Text className="editor-content" as="div">
        <div
          dangerouslySetInnerHTML={{
            __html: setContent(ipoDetails?.displayText?.details?.part1),
          }}
        />
        <p>{ipoDetails?.displayText?.details?.part2}</p>
      </Text>

      <IPOAnalysis
        seoName={ipoDetails?.seoName}
        seoMeta={ipoDetails?.seoMeta}
        logoLink={ipoDetails?.logoUrl}
        videoUploadDate={ipoDetails?.displayText2?.videoUploadDate}
        videoDuration={ipoDetails?.displayText2?.videoDuration}
        ipoVideoLink={ipoDetails?.displayText2?.videoUrls?.[0]}
        sliderImages={ipoDetails?.displayText2?.seoImages?.slider}
      />

      <div className="mb40">
        <View flexWrap="wrap">
          {ipoDetails?.detail?.registrar &&
            ipoDetails?.detail?.registrarContact?.contactNumber &&
            ipoDetails?.detail?.registrarContact?.email && (
              <RegistrarInfoCard
                name={ipoDetails?.detail?.registrar}
                contactNumber={
                  ipoDetails?.detail?.registrarContact?.contactNumber
                }
                email={ipoDetails?.detail?.registrarContact?.email}
              />
            )}
          {ipoDetails?.detail?.redHerringProspectusUrl && (
            <RedherringCard
              redHerringProspectusUrl={
                ipoDetails?.detail?.redHerringProspectusUrl
              }
            />
          )}
        </View>
      </div>
      {ipoDetails?.faqs && ipoDetails.faqs.length > 0 && (
        <div className="mb30">
          <Faqs faqs={ipoDetails?.faqs} title="FAQs" />
        </div>
      )}
    </View>
  );
};
